/**
 * @file carousel.tokens.ts
 * MD3 Expressive Carousel — Design tokens ported from Material 3 Carousel Specs.
 * All dimensional values are in px (dp equivalents for web).
 * Colors reference CSS custom properties — no hardcoded hex.
 * @see docs/m3/carousel/Carousel_Specs_Material_Design_3.md
 */

export const CarouselTokens = {
	/** Corner radius shape (M3 extraLarge shape: 28dp) */
	containerRadius: 28,

	/** Small item dimension limits (dp) */
	smallItemMin: 40,
	smallItemMax: 56,

	/** Layout defaults (dp) */
	itemSpacing: 8,
	contentPadding: 16,
	verticalPadding: 8,

	/** Interactive state overlays */
	hoverOpacity: 0.08,
	focusOpacity: 0.1,
	pressedOpacity: 0.1,
	disabledOpacity: 0.38,

	/** Focus indicator dimensions */
	focusThickness: 3,
	focusOffset: 2,

	/** Touch target minimum size for accessibility (WCAG 2.1 AAA / M3) */
	minTouchTargetSize: 48,

	/** CSS Custom Property token maps for fallback and runtime injection */
	cssVars: {
		shape: "--carousel-item-shape",
		spacing: "--carousel-item-spacing",
		contentPadding: "--carousel-content-padding",
		verticalPadding: "--carousel-vertical-padding",
		smallMin: "--carousel-small-item-min",
		smallMax: "--carousel-small-item-max",
		hoverOpacity: "--carousel-hover-opacity",
		focusThickness: "--carousel-focus-thickness",
		focusOffset: "--carousel-focus-offset",
		pressedOpacity: "--carousel-pressed-opacity",
		disabledOpacity: "--carousel-disabled-opacity",
	},
} as const;

export type CarouselTokensType = typeof CarouselTokens;
